import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import {
  addUpdateConfigurationDetailsFailure,
  addUpdateConfigurationDetailsSuccess,
  getConfigurationDetailsFailure,
  getConfigurationDetailsSuccess,
} from "./actions";
import {
  ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST,
  GET_CONFIGURATION_DETAILS_REQUEST,
} from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const getRequest = async (url: string) => {
  const { data } = await apiService.get(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* getConfigurationDetailsSaga(action: any) {
  try {
    const response: {
      id: number;
      pop3Server: string;
      pop3Port: number;
      pop3Email: string;
      pop3Password: string;
      pop3SecureSSL: string;
      sendFailureNotifications: boolean;
      failureRecipients: string;
      sendSuccessNotifications: boolean;
      successRecipients: string;
      sendInvalidNotifications: boolean;
      invalidRecipients: string;
      updatedBy: number;
    } = yield call(getRequest, action.url);

    yield put(getConfigurationDetailsSuccess(response));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(getConfigurationDetailsFailure(errorMessage));
  }
}

function* addUpdateConfigurationDetailsSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdateConfigurationDetailsSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateConfigurationDetailsFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* configurationSaga() {
  yield takeLatest(
    GET_CONFIGURATION_DETAILS_REQUEST,
    getConfigurationDetailsSaga
  );
  yield takeLatest(
    ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST,
    addUpdateConfigurationDetailsSaga
  );
}
